import reducer from "./reducer";
export { default as EvaluationProcessDefinition } from "./components/index";
export { default as evaluationProcessDefinitionReducerName } from "./constants";
export default reducer;
